import React from 'react';
import { Cake, Gift } from "lucide-react";
import { Button } from "../ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";

const daysLabel = (d) => (d === 0 ? "¡Es hoy!" : d === 1 ? "¡Es mañana!" : `Faltan ${d} días`);

export const UpcomingBirthdays = ({ notifications = [], onGift }) => {
  if (notifications.length === 0) return null;
  return (
    <section data-testid="upcoming-birthdays" className="rounded-3xl bg-brand-dark text-white p-6 md:p-8 relative overflow-hidden">
      <div className="absolute -right-10 -top-10 w-48 h-48 rounded-full bg-brand-blue/40 blur-2xl" />
      <div className="absolute -left-6 bottom-0 w-32 h-32 rounded-full bg-brand-green/30 blur-2xl" />
      <div className="relative">
        <div className="flex items-center gap-2 mb-1">
          <Cake className="w-5 h-5 text-brand-green" />
          <p className="text-xs uppercase tracking-[3px] font-bold text-brand-green">Cumpleaños cercanos</p>
        </div>
        <h3 className="text-2xl font-extrabold mb-6">Que tu regalo llegue a tiempo</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {notifications.map((n) => (
            <div key={n.account_id} data-testid={`birthday-card-${n.account_id}`} className="rounded-2xl bg-white/10 backdrop-blur-md border border-white/10 p-4 flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <Avatar className="w-11 h-11 border-2 border-brand-green/60">
                  <AvatarImage src={n.profile_picture} />
                  <AvatarFallback className="bg-brand-blue text-white font-bold">{n.child_name.charAt(0)}</AvatarFallback>
                </Avatar>
                <div className="min-w-0">
                  <p className="font-bold truncate">{n.child_name} {n.child_lastname}</p>
                  <p className="text-xs text-white/70">Cumple {n.turning_age} · {n.relation === "child" ? "Tu hijo/a" : "Tu ahijado/a"}</p>
                </div>
              </div>
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-bold text-brand-green">{daysLabel(n.days_until)}</span>
                <Button size="sm" data-testid={`birthday-gift-btn-${n.account_id}`} onClick={() => onGift(n)} className="h-8 rounded-full bg-brand-green text-brand-dark font-bold hover:bg-brand-green/90">
                  <Gift className="w-3.5 h-3.5 mr-1" /> Enviar regalo
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
